define('views/presence/Podio.Views.Presence.PresenceBar',['require','underscore','jquery','lib/jquery/jquery.bounds','lib/jquery/jquery.cssAsInteger','jquery.scrollTo','lib/backbone/Backbone.PodioView','views/lib/Podio.Views.SlotMachineCount','views/presence/Podio.Views.Presence.PresenceBar.Followers','views/presence/Podio.Views.Presence.PresenceBar.Viewers','views/presence/Podio.Views.Presence.PresenceBar.Info','lib/Podio.Viewport','lib/Podio.Event','jst!presence/presence_bar/_bar'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.bounds');
  require('lib/jquery/jquery.cssAsInteger');
  require('jquery.scrollTo');

  var PodioView = require('lib/backbone/Backbone.PodioView');
  var SlotMachineCountView = require('views/lib/Podio.Views.SlotMachineCount');
  var FollowersView = require('views/presence/Podio.Views.Presence.PresenceBar.Followers');
  var ViewersView = require('views/presence/Podio.Views.Presence.PresenceBar.Viewers');
  var InfoView = require('views/presence/Podio.Views.Presence.PresenceBar.Info');
  var PodioViewport = require('lib/Podio.Viewport');
  var PodioEvent = require('lib/Podio.Event');

  var jstBar = require('jst!presence/presence_bar/_bar');

  return PodioView.extend({

    className: 'podio-presence-bar',

    podioEvents : {
      'click .followers.enabled'      : 'onFollowersClicked',
      'click .viewers.enabled'        : 'onViewersClicked',
      'click .info'                   : 'onInfoClicked'
    },

    initialize: function(options) {

      this.bindAll('detectPosition');

      this.elmContainer = this.options.elmContainer;
      this.elmWindow = $(window);
      this.viewportHelper = new PodioViewport({
        offsets : {
          top: -42, // Header height
          bottom: 55 // Presencebar height
        }
      });

      // Default data
      this.model = this.options.model;

      // Options
      this.features = this.options.features;
      this.stickinessEnabled = this.options.stickinessEnabled;
      this.shouldRenderNewCommentsInfo = this.options.shouldRenderNewCommentsInfo || false;

      this._super();
    },

    hasFeature: function(feature) {
      return _.include(this.features, feature);
    },

    dispose: function() {
      PodioEvent.unbind(undefined, undefined, this);

      if (this.followersView) {
        this.followersView.dispose();
      }
      if (this.viewersView) {
        this.viewersView.dispose();
      }
      if (this.infoView) {
        this.infoView.dispose();
      }

      this._super();
    },

    updatePosition: function() {
      var elmMainColumnInner = $('.main-content .col:first > .inner.grid-spacer, .main-content .grid-column-3-4 .grid-tile');

      var bounds = elmMainColumnInner.bounds();

      this.elm.css({
        left: bounds.left + elmMainColumnInner.cssAsInteger('paddingLeft'),
        width: bounds.width
      });
    },

    render: function() {

      var html = this.getTemplate(jstBar);

      this.elm.html(html);
      this.elm.appendTo(this.elmContainer);

      // Init subviews
      if (this.hasFeature('followers')) {
        if (!this.followersView) {
          this.followersView = new FollowersView({
            elmContainer: this.elm.find('.followers-wrapper'),
            count: this.model.get('subscribed_count')
          });
        }

        this.followersView.count = this.model.get('subscribed_count');
        this.followersView.updateElementReference(this.elm.find('.followers-wrapper'));
        this.followersView.render();
      }

      if (this.hasFeature('viewers')) {
        if (!this.viewersView) {
          this.viewersView = new ViewersView({
            elmContainer: this.elm.find('.viewers-wrapper'),
            model: this.model
          });
        }

        this.viewersView.updateElementReference(this.elm.find('.viewers-wrapper'));
        this.viewersView.render();
      }

      if (this.hasFeature('comments') || this.hasFeature('typing')) {
        if (!this.infoView) {
          this.infoView = new InfoView({
            elmContainer: this.elm,
            model: this.model,
            hasComments: this.hasFeature('comments'),
            hasTyping: this.hasFeature('typing'),
            shouldRenderNewCommentsInfo: this.shouldRenderNewCommentsInfo
          });
        }

        this.infoView.updateElementReference(this.elm);
        this.infoView.render();
      }

      this.detectPosition();

      // Bind events
      PodioEvent.bind('resize', this.detectPosition, this);
      PodioEvent.bind('scroll', this.detectPosition, this);

    },

    makeFixed: function() {
      this.updatePosition();
      this.elm.removeClass('fixed-top');
      this.elm.addClass('fixed');

      this.trigger('presenceBarView:layoutChanged', 'fixed');
    },

    makeTopFixed: function() {
      this.makeFixed();
      this.elm.addClass('fixed-top');

      this.trigger('presenceBarView:layoutChanged', 'fixed-top');
    },

    makeStatic: function() {
      this.elm.removeClass('fixed');
      this.elm.removeClass('fixed-top');
      this.elm.css('width', '');

      this.trigger('presenceBarView:layoutChanged', 'static');
    },

    detectPosition: function() {
      var elmMetaWrapper = $('.presence-bar-wrapper');
      var viewportInfo = this.viewportHelper.getInfo(elmMetaWrapper);

      if (this.stickinessEnabled) {

        if (viewportInfo.isBelowFoldTopEdge) {
          this.makeFixed();
        } else if (viewportInfo.isAboveTop) {
          this.makeTopFixed();
        } else {
          this.makeStatic();
        }

      } else {
        this.makeStatic();
      }

    },

    onFollowersClicked: function(elmTarget, e) {
      this.trigger('presenceBarView:onFollowersListTriggered');
    },

    onViewersClicked: function(elmTarget, e) {
      e.stopPropagation(); // Temp solution until we stopPropagation by default, to avoid event leaks.
      this.trigger('presenceBarView:onViewersListTriggered');
    },

    onInfoClicked: function(elmTarget, e) {

      if (this.elm.hasClass('state-is-regular-comment')) {
        var wrapperOffset = $('.presence-bar-wrapper').offset();

        this.elmWindow.scrollTo({
          left: 0,
          top: wrapperOffset.top - 19 // item-comments-wrapper top margin
        }, 500);
      }
      else if (this.elm.hasClass('state-is-new-comment')) {
        this.trigger('presenceBarView:onNewCommentsInfoClicked');
      }

    }

  });

});

